@if (form; as form) {
  <fieldset [formGroup]="form">
    <legend>
      Adres korespondencyjny
    </legend>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"country" as controlName'>
          <label [for]='controlName'>
            Kraj
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę kraju'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"voivodeship" as controlName'>
          <label [for]='controlName'>
            Województwo
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę województwa'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"county" as controlName'>
          <label [for]='controlName'>
            Powiat
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę powiatu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"municipality" as controlName'>
          <label [for]='controlName'>
            Gmina
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę gminy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"postalCode" as controlName'>
          <label [for]='controlName'>
            Kod pocztowy *
          </label>
          <input
            [id]='controlName'
            mask='00-000'
            [dropSpecialCharacters]='false'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu kod pocztowy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"postOffice" as controlName'>
          <label [for]='controlName'>
            Poczta
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu pocztę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"street" as controlName'>
          <label [for]='controlName'>
            Ulica *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"houseNumber" as controlName'>
          <label [for]='controlName'>
            Nr domu *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr domu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
          <label [for]='controlName'>
            Nr mieszkania
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr mieszkania'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
}
